module.exports = __webpack_public_path__ + "img/okSemAlarme.d861ec98.jpg";